import { AuthLayout } from '../components/AuthLayout';
import ResetPasswordForm from './ResetPasswordForm';

const ResetPassword = () => (
  <AuthLayout>
    <ResetPasswordForm />
  </AuthLayout>
);

export default ResetPassword;
